module.exports = __webpack_public_path__ + "media/application/images/ui/accredited-businesses-7352a4731b1a9ad3053ba32247beeeb1.jpg";